/**
 * frontend/src/api/branchCatalog.js
 *
 * Client for the branch catalogue (routes/branchCatalogRoutes.js, mounted at
 * /api/catalog/branches): what one product is like at one of the vendor's
 * locations. A location is "main", an outlet id, or "all" (head office only).
 *
 *   GET   /:vendorUserId/states?location=   { vertical, parentId, todayKey, rows: [StateDTO] }
 *   PATCH /:vendorUserId/products/:id       { location, available?, soldOut?, price? }
 *   PATCH /:vendorUserId/products           { location, productIds, available?, soldOut? }
 *
 * StateDTO = { location, productId, available, soldOut: { active, until,
 * dateKey, live, reason }, price, priceInEffect, updatedAt, updatedBy }.
 * No row means: on sale here, not sold out, head office price.
 *
 * `vendorUserId` is always the OWNER's Users id (utilities/vendorScope.js
 * vendorOwnerIdOf). Every call goes through `dashboardApi`, so the token,
 * country header and refresh interceptor apply.
 */
import { dashboardApi as API } from "./index.js";

const base = (vendorUserId) => `/api/catalog/branches/${vendorUserId}`;

export const apiBranchStates = (vendorUserId, location) =>
  API.get(`${base(vendorUserId)}/states`, { params: location ? { location } : undefined });

/** body: { location, available?: boolean, soldOut?: { active, until?, reason? }, price?: number|null } */
export const apiSetBranchProduct = (vendorUserId, productId, body) =>
  API.patch(`${base(vendorUserId)}/products/${productId}`, body);

/** body: { location, productIds: string[], available?, soldOut? } (no price in bulk) */
export const apiSetBranchProducts = (vendorUserId, body) =>
  API.patch(`${base(vendorUserId)}/products`, body);
